import axios from 'axios';
import store, { persistor, SET_TOKEN } from '../../store';

// ----------------------------------------------------------------------

const reissue = async () => {
  return await axios.post('/api/auth/reissue')
    .then((response) => {
      const token = response.data.data.accessToken;
      store.dispatch( SET_TOKEN(token) );
    })
    .catch(() => {
      return Promise.reject({
        response: {
          data: {
            code: 'ERR-REISSUE'
          }
        }
      });
    });
};

export default reissue;